module.exports = __webpack_public_path__ + "f1dd22ab01aadb80913ffc9890863c51.svg";